export default __webpack_public_path__ + "static/rohingyacamp-244cee3dc943ce000d4e3d0da755dc18.jpg";